import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../App.css'
import Header from '../components/Header'
import ClosedCollectionContent from '../components/ClosedCollectionContent'
import { Logger } from "react-remote-logger"

class ClosedCollection extends Component {
  componentDidMount() {
    Logger({
      'timestamp': (new Date()).toLocaleString(),
      'level': 'info',
      'user_id': localStorage.user_id,
      'user': localStorage.user_email,
      'organization': localStorage.organization,
      'action': 'GET',
      'url': window.location.href,
      'message': `GET ${window.location.href}`
    })
  }

  render () {
    return (
      <div className='App'>
        <Header
          enabled='closedCollection'
          org={this.props.match.params.org}
        />
        <ClosedCollectionContent
          org={this.props.match.params.org}
        />
      </div>
    )
  }
}

ClosedCollection.propTypes = {
  match: PropTypes.object
}

export default ClosedCollection
